// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Caption_Wrapper__15NkX container grid grid--col-12","Inner":"Caption_Inner__2XZa4","Title":"Caption_Title__IoEbg","Description":"Caption_Description__3ujaA"};